import styled from 'styled-components';

export const SidebarSection = styled.section`
  margin: 0 0 2.5rem;

  h1 {
    font-size: 1.6rem;
    color: ${({theme}) => theme.color.darkGray};
    font-weight: 600;
    margin-bottom: 0.6rem;
  }
`;
